import {ROP_MIN_LABEL} from "../../properties";

export const labels = {
	lt_days: "Lead Time in Days",
	cl_name: "Material Class",
	description: "Short Text",
	material: "Material Number",
	part_number: "Part Number",
	stock_level: "Stock on Hand",
	unit: "Unit",
	rop: ROP_MIN_LABEL,
	max: "MAX",
	created_date: "Created Date",
	demand: "Annual Demand",
	"EQ BOM Count": "Count of FLOCs",
	quantity: "Count of FLOCs",
	"Trans PA (ave)": "Transactions per Year",
	"Trans 4Y": "Total number of transactions",
	PotOb: "Is Obsolete Item",
	Insurance: "Is Insurance Item",
	price: "Price per Unit",
	Total$: "Total Price",
	Duplicate: "Is Duplicate item",
	criticality: "Highest Criticality",
	equipments: "Number of Equipments",
	installed: "Quantity Installed",
	pms: "PMP's Associated",
	approved: "Is Item Approved",
	appr_max: "Approved MAX",
	appr_min: `Approved ${ROP_MIN_LABEL}`,
};
